import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 70px;
  background: rgba(0, 0, 0, 0.95);
  border-bottom: 2px solid #00ffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  z-index: 1000;
  backdrop-filter: blur(10px);
`;

const Logo = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: #00ffff;
  letter-spacing: 4px;
  text-transform: uppercase;
  text-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
`;

const Subtitle = styled.div`
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-top: 4px;
  opacity: 0.8;
`;

const Nav = styled.nav`
  display: flex;
  gap: 24px;
  align-items: center;
`;

const NavLink = styled.a`
  color: #00ffff;
  text-decoration: none;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  transition: all 0.2s;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 2px;
    background: #00ffff;
    transition: width 0.2s;
  }

  &:hover {
    text-shadow: 0 0 10px rgba(0, 255, 255, 0.8);
  }

  &:hover:after {
    width: 100%;
  }
`;

const Header = () => {
  return (
    <HeaderContainer>
      <div>
        <Logo>RAI</Logo>
        <Subtitle>Recursive Architecture Intelligence</Subtitle>
      </div>
      <Nav>
        <NavLink href="https://recursivearchitectureintelligence.com" target="_blank">
          Home
        </NavLink>
        <NavLink href="https://recursivearchitectureintelligence.com/research" target="_blank">
          Research
        </NavLink>
        <NavLink href="https://github.com/rai-institute" target="_blank">
          GitHub
        </NavLink>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;